module.exports = __webpack_public_path__ + "static/media/smallTick.9949c68a.svg";